export default __webpack_public_path__ + "static/media/gym-website.4d4a728d.jpg";